import { cn } from '../../lib/utils';

export default function AppButton({
  icon,
  textButton,
  onClick,
  type,
  disabled = false,
  isIconButton = false,
  isLoading = false,
  secondary = false,
  fullWidth = false,
  redVariant = false,
  modalVariant = false,
  smallVariant = false,
  blueVariantborder = false,
  greenVariantborder = false,
  variantLogin = false,
  variantAcquisition = false,
  variantAcquisitionWhite = false,
  ...restButtonProps
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`truncate px-2 py-4 transition-all duration-150 ease-linear rounded-xl ${
        secondary
          ? 'bg-transparent hover:opacity-60 focus:ring-0 border text-main-color border-main-color focus:bg-transparent font-medium rounded-xl text-sm px-5 py-3 text-center flex items-center justify-center shadow-md min-w-[130px]'
          : greenVariantborder
          ? 'text-[#80a61b] uppercase bg-white hover:opacity-60 border border-[#80a61b] focus:ring-0 focus:outline-none font-medium rounded-xl text-sm px-5 py-3 text-center flex items-center justify-center shadow-md min-w-[130px]'
          : blueVariantborder
          ? 'text-main-color bg-white hover:opacity-60 border border-main-color focus:ring-0 focus:outline-none font-medium rounded-lg text-sm px-5 py-3 text-center flex items-center justify-center shadow-md min-w-[130px]'
          : variantLogin
          ? 'text-main-color lg:text-white bg-white lg:bg-main-color hover:opacity-80 focus:ring-0 focus:outline-none font-medium rounded-lg px-5 py-3 text-center flex items-center justify-center shadow-md min-w-[130px]'
          : variantAcquisition
          ? 'text-white bg-main-color hover:opacity-80 focus:ring-0 focus:outline-none font-medium rounded-lg px-5 py-3 text-center flex items-center justify-center shadow-md min-w-[130px]'
          : redVariant
          ? 'text-white bg-red-600 hover:opacity-60 border border-red-400 focus:ring-0 focus:outline-none font-medium rounded-xl text-sm px-5 py-3 text-center flex items-center justify-center shadow-md min-w-[130px]'
          : modalVariant
          ? 'text-main-color  bg-white hover:border-opacity-20 focus:ring-0 focus:outline-none font-medium border border-main-color rounded-lg px-5 py-3 text-center flex items-center justify-center shadow-md min-w-[130px]'
          : variantAcquisitionWhite
          ? 'text-main-color bg-main-white border border-main-color hover:opacity-80 focus:ring-0 focus:outline-none font-medium rounded-lg px-5 py-3 text-center flex items-center justify-center min-w-[130px]'
          : 'text-white bg-main-color hover:opacity-60 border border-main-color focus:ring-0 focus:outline-none font-medium rounded-xl text-sm px-5 py-3 text-center flex items-center justify-center shadow-md min-w-[130px]'
      }
      ${isIconButton && 'min-w-[32px] px-2'}
      ${smallVariant && 'min-w-[50px] px-3 text-xs'}
      ${isLoading ? 'cursor-wait' : ''}
      ${fullWidth && !isIconButton ? 'w-full' : ''}
      ${
        disabled
          ? 'py-3 cursor-not-allowed hover:opacity-100 !bg-disabled !text-white'
          : ''
      }
      `}
      onClick={(e) => {
        if (disabled || isLoading) return;
        onClick(e);
      }}
      {...restButtonProps}
    >
      {icon && !isLoading && icon}
      {isLoading && (
        <div
          className={cn(
            'mr-2 w-4 h-4 rounded-full animate-spin border border-dashed border-blue-300 border-t-transparent',
            redVariant && 'border-red-300'
          )}
        />
      )}
      {icon && !isIconButton && <div className='mx-2' />}
      {!isLoading ? textButton : 'carregando...'}
    </button>
  );
}
